<!-- Learn details page design -->
<!--
<main>
  <app-breadcrumb [breadCrumbs]="breadCrumbs"></app-breadcrumb>
</main>
     <app-pageloader [pageStatus]="pageLoader"></app-pageloader>-->
<!-- banner section start-->
<!-- <button (click)="reset()">RESET</button> -->
<main>

  <div class="container-box">
    <div class="alert valign-children-middle mar-top-20" *ngIf="isFirstnetCustomer">
      <div class="alert-error" role='alert' aria-label="Alert">
        <i class="icon-badgealert" aria-hidden="true"></i>
      </div>
      <div>
        <h2 tabindex="-1">Error</h2>
        <p *ngIf="detailErrorMessage!=null">{{detailErrorMessage}}</p>
        <p class="error-message" *ngIf="isFirstnetCustomer">{{firstnetCustomerErrormessage}}<a
            href='http://localcontrol.firstnet.com' class="firstnetErrorMessageLink" target="_blank"> here
          </a>{{firstnetCustomerErrormessage1}}</p>
      </div>
      <div class="pull-right close" (click)="dismissInfo()" role="img" aria-label="close" tabindex="0"></div>
    </div>
  </div>

  <div class="container-box">
    <div class="alert valign-children-middle mar-top-20" *ngIf="isMyAttCustomer">
      <div class="alert-error" role='alert' aria-label="Alert">
        <i class="icon-badgealert" aria-hidden="true"></i>
      </div>
      <div>
        <h2 tabindex="-1">Error</h2>
        <p *ngIf="detailErrorMessage!=null">{{detailErrorMessage}}</p>
        <p class="error-message" *ngIf="isMyAttCustomer">{{myAttCustomerErrormessage}}<a
            href='http://localcontrol.firstnet.com' class="firstnetErrorMessageLink" target="_blank"> here
          </a>{{myAttCustomerErrormessage1}}</p>
      </div>
      <div class="pull-right close" (click)="dismissInfo()" role="img" aria-label="close" tabindex="0"></div>
    </div>
  </div>

  <div *ngIf = "!isFirstnetCustomer && !isMyAttCustomer" class="hide-acc">  
    <section aria-labelledby="bannerNameSection" *ngIf="!productDetail.lightBackground" class="bannerNameSectionSmall">
      <div class="banner-section" id="banner-section-dark">
        <figure>
          <img class="hide-small" src="{{productDetail.media && productDetail.media.largeImageUrl}}"
            alt="Banner Image" />
          <img style="height:200px;" class="show-small"
            src="{{productDetail.media && productDetail.media.smallImageUrl}}" alt="Banner Image" />
        </figure>
        <div class="banner-caption" *ngIf="productDetail != null">
          <div class="container-box">
            <div class="row">
              <div class="col-lg-12 bannerHeader">
                <h1 id="bannerNameSection" [innerHTML]="productDetail.bannerName"></h1>
                <div class="col-lg-12 product-text">
                  <p class="col-lg-12 product-text" [innerHTML]="productDetail.plainDescription"></p>
                  <!-- <p *ngIf="productDetail.id == 'androidzerotouch'" class="col-lg-12 product-text">{{productDetail.subDescription}}</p> -->
                  <p class="col-lg-12 product-text">
                    <button (click)="next()" class="btn btn-secondary" id="banner-button">
                      {{bannerButtonLabel}} </button>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section aria-labelledby="lightBannerNameSection" *ngIf="productDetail.lightBackground">
      <div class="banner-section" id="banner-section-light">
        <figure *ngIf="fivegpageflag">
          <img class="hide-small" style="top: -400px; width: 100%; height: 960px;" src="{{productDetail.media && productDetail.media.largeImageUrl}}"
            alt="Banner Image" />
          <img style="height:188px; width: 110%;" class="show-small"
            src="{{productDetail.media && productDetail.media.smallImageUrl}}" alt="Banner Image" />
        </figure>
        <figure *ngIf="!fivegpageflag">
          <img class="hide-small productImage" src="{{productDetail.media && productDetail.media.largeImageUrl}}"
            alt="Banner Image" />
          <img style="height:188px;" class="show-small"
            src="{{productDetail.media && productDetail.media.smallImageUrl}}" alt="Banner Image" />
        </figure>
        <div class="banner-caption" *ngIf="productDetail != null">
          <div class="container-box heading">
            <div class="row">
              <div class="col-lg-12" role="heading" aria-level="1">
                <h1 *ngIf="!fivegauthpageflag && !fivegpageflag" id="lightBannerNameSection"
                  [innerHTML]="productDetail.bannerName"></h1>
                <p *ngIf="!fivegauthpageflag && !fivegpageflag" class="col-lg-12 light-product-text"
                  [innerHTML]="productDetail.plainDescription"></p>
                <h1 *ngIf="fivegauthpageflag || fivegpageflag" id="whiteBannerName"
                  [innerHTML]="productDetail.bannerName"></h1>
                <p *ngIf="fivegauthpageflag || fivegpageflag" class="col-lg-12 white-product-text"
                  [innerHTML]="productDetail.plainDescription"></p>

                <p *ngIf="fansAvailable">
                  <label class="checkbox">
                    <input type="checkbox" (change)="changeEvent($event)">
                    <i class="skin"></i>
                    <span class="checkboxText">{{productDetail.checkboxText}}</span>
                  </label>
                </p>
                <p class="col-lg-12 product-text">
                  <button (click)="next()" class="btn btn-secondary" id="light-banner-button" [disabled]="!selectedbox">
                    {{bannerButtonLabel}} </button>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- banner section end-->

    <!-- list of tabs start -->
    <section class="tabslistsection" *ngIf="!fivegauthpageflag || isFn">
      <div class="container-box overview">
        <div class="tabslistrow tabrow row" id="tabslist">
          <div *ngFor="let tab of tabsListArray">
            <div class="col-lg-12 tabitem">
              <a (click)="tabClick(tab)">{{tab}}</a>
            </div>
          </div>
        </div>
        <div class="col-lg-12 tabline" style="margin-left: 100px;"></div>
      </div>
    </section>
    <!-- list of tabs end -->

    <!-- list of 5g auth tabs start -->
    <section class="tabslistsection" *ngIf="fivegauthpageflag && !isFn">
      <div class="container-box">
        <div class="row tabslistrow" id="tabslist">
          <div *ngFor="let tab of authTabsListArray">
            <div class="col-lg-12 tabitem">
              <a (click)="tabClick(tab)">{{tab}}</a>
            </div>
          </div>
        </div>
        <div class="col-lg-12 tabline"></div>
      </div>
    </section>
    <!-- list of 5g auth tabs end -->

    <!-- short description-->
    <section>
      <div class="shortdescription" id="shortdescription">{{productDetail.shortDescription}}</div>
    </section>
    <section>
      <div class="shortdescription1" *ngIf="fivegpageflag" id="shortdescription1">{{productDetail.shortDescription1}}
      </div>
    </section>

    <!-- start of programs -->
    <div class="shortdec" *ngIf="productDetail.programsHeading">
      <h4 class="programs-title title-heading">{{productDetail.programsHeading}}</h4>
      <div class="programs">

        <div class="program" *ngFor="let program of productDetail.programs">
          <a [href]="program.link"><img class="program-img" [src]="program.image" /></a>
          <a [href]="program.link">
            <h3 class="program-title">{{program.heading}}</h3>
          </a>
          <p class="program-details">{{program.details}}</p>
        </div>
      </div>
      <p class="programs-note">{{productDetail.programsNote}}</p>


      <!-- start of getting started -->
      <div class="row requirementsection" id="StartedHeader" *ngFor="let product of productDetail.products">
        <div id="GettingStarted" class="gettingStartedHeader">{{product.gettingStarted}}</div>
        <div class="outerbox">{{product.gettingStartedNote}}</div>
        <div class="outerbox">
          <div class="largebox" *ngFor="let detail of product.gettingStartedArray">
            <div class="line"></div>
            <div class="largetext" [innerHTML]="detail"></div>
          </div>
        </div>
        <br>
      </div>

    </div>
    <!-- end of programs To get started in Device Management Program:-->

    <!-- benefits section start-->
    <div *ngIf="productDetail.benefitsHeading" class="benefitContent">
      <div class="benefitsheader overview">
        <p class="benefitsheaderpara">{{productDetail.benefitsHeading}}</p>
      </div>
      <div class="benefits" id="benefits">
        <div class="benefitsimage">
          <figure>
            <img class="hide-sm" align="right" src="{{productDetail.media && productDetail.media.benefitsImageUrl}}"
              alt="" />
            <img style="height:243px; padding-right: 15px; margin-left: -10px;" class="show-sm"
              src="{{productDetail.media && productDetail.media.benefitsSmallImageUrl}}" alt="" />
          </figure>
        </div>
        <div class="benefitstext overview" [innerHTML]="productDetail.benefitsText"></div>
      </div>
    </div>
    <!-- benefits section end -->

    <!-- subscription section start-->
    <div class="subscriptionsection" *ngIf="authSubscription" id="subscriptionsection">
      <div class="subscriptioncontent" id="subscriptionContent">
        <p class="tabheading">{{productDetail.subscriptionHeading}}</p>
        <p class="subheading">{{productDetail.subscriptionSubHeading}}</p>
        <!-- <div class="subimages">
          <img class="subimage" src="{{productDetail.media && productDetail.media.groupBasedUrl}}" alt="E-FOTA">
          <img class="subimage" src="{{productDetail.media && productDetail.media.accountBasedUrl}}" alt="E-FOTA">
        </div> -->
        <div class="subscription-images">
          <div class="subscription-cards">
            <div class="subscription-card">
              <h2>{{productDetail.subscriptionGroupHeading}}</h2>
              <p>{{productDetail.subscriptionGroupDesc}}</p>
              <p class="starting-text">{{productDetail.starting1}}</p>
              <p class="starting-text1">{{productDetail.starting}}</p>
              <p class="bold-price">{{productDetail.groupPrice}}</p>
              <p class="devices-no">{{productDetail.devicesNo}}</p>
              <p class="plan-list">{{productDetail.subscriptionPlansGroupBased}}</p>
            </div>
            <div class="card-flex">
              <app-bluebox></app-bluebox>
            </div>
          </div>
          <div class="subscription-cards">
            <div class="subscription-card">
              <h2>{{productDetail.subscriptionAccountHeading}}</h2>
              <p>{{productDetail.subscriptionAccountDesc}}</p>
              <p class="starting-text-second">{{productDetail.starting}}</p>
              <p class="bold-pricing">{{productDetail.accountPricing}}</p>
              <div class="plan-lists-div">
                <p class="plan-lists" *ngFor="let plan of productDetail.subscriptionPlansAccountBased;">{{plan}}</p>
              </div>
            </div>
            <div class="card-flex">
              <app-bluebox></app-bluebox>
            </div>
          </div>
        </div>
        <div class="subeligiblebox">
          <p class="subeligibletext">{{productDetail.subscriptionEligibleText}}</p>
        </div>
      </div>
    </div>
    <!-- subscription section end-->

    <!-- fiveg Auth subscription section start-->
    <div class="subscriptionsection" *ngIf=" fivegauthpageflag && !isFn" id="subscriptionsection">
      <div class="subscriptioncontent" id="subscriptionContent">
        <p class="tabheading">{{productDetail.subscriptionHeading}}</p>
        <p class="subheading">{{productDetail.subscriptionSubHeading}}</p>
        <div class="subscription-fiveg-images ">
          <div class="subscription-fiveg-cards" *ngFor="let subscription of productDetail.subscribe">
            <div class="subscription-fiveg-card">
              <h2>{{subscription.subscriptionPackageHeading}}</h2>
              <p class='subscription-sub-content'>{{subscription.subscriptionPackageSubHead}}</p>
              <div class="subscription-descheading">{{productDetail.subscriptionDescHeading}}</div>
              <div class="subscription-desc-content">{{subscription.subscriptionPackageDesc}}</div>
              <div class="subscription-goodheading">{{productDetail.subscriptionGoodForHeading}}</div>
              <div class="keyfeatures" [innerHTML]="subscription.subscriptionPackageGoodFor"></div>
              <div class="subscription-goodheading">{{productDetail.subscriptionFeaturesHeading}}</div>
              <div class="keyfeatures " [innerHTML]="subscription.subscriptionPackageKeyFeatures"></div>
              <!-- <div class="subscription-goodheading">{{productDetail.pricingHeading}}</div> -->
              <!-- <div class="bold-price">{{subscription.packagePrice}}</div> -->
              <!-- <div class="devices-no">{{subscription.perSubscriber}}</div> -->
              <!-- <div class="devices-no">{{subscription.volumeDiscount}}</div> -->
              <!-- <div class="sub-notes">
                <span class="note-heading">{{subscription.noteHeading}}</span>
                <span class="plan-fiveg-note">{{subscription.subscriptionPlansPackage}}</span>
              </div> -->
              <div class="request-solution">
                <button (click)="next()" class="btn btn-secondary">
                  {{subscription.requestSolution}} </button>
              </div>
            </div>
            <div class="card-flex">
              <app-bluebox></app-bluebox>
            </div>
          </div>
        </div>
        <div class="subeligiblebox">
          <p class="subeligibletext">{{productDetail.subscriptionEligibleText}}</p>
        </div>
      </div>
    </div>
    <!-- fiveg Auth subscription section end-->

    <!--fiveg Auth usecases sction start-->
    <div class="row usecases-section" id="usecases-section" *ngIf="fivegauthpageflag && !isFn ">
      <div class="usecasesHeading">{{productDetail.UseCasesHeader}}</div>
      <div class="usecasesDesc">{{productDetail.UseCasesDesc}}</div>
    </div>
    <div class="usecasesDetails" *ngIf="fivegauthpageflag && !isFn ">

      <div class=" usecase-cards">
        <figure>
          <img class="image-icon" src="{{productDetail.RemoteMonitoring.Icon}}" alt="" />
        </figure>
        <div class="usecase-subheading">{{productDetail.RemoteMonitoring.Heading}}</div>
        <mat-accordion>
          <mat-expansion-panel (opened)="panelOpenRemote = true" (closed)="panelOpenRemote = false">
            <mat-expansion-panel-header aria-label='usecase-panel'></mat-expansion-panel-header>
            <div class="usecase">
              <div [innerHTML]="productDetail.RemoteMonitoring.Description"></div>
            </div>
          </mat-expansion-panel>

        </mat-accordion>
        <div class="card-flex">
          <app-bluebox></app-bluebox>
        </div>
      </div>

      <div class="usecase-cards ">
        <figure>
          <img class="image-icon" src="{{productDetail.Transportation.Icon}}" alt="" />
        </figure>
        <div class="usecase-subheading">{{productDetail.Transportation.Heading}}</div>
        <mat-accordion>
          <mat-expansion-panel (opened)="panelOpenTransport = true" (closed)="panelOpenTransport = false">
            <mat-expansion-panel-header aria-label='usecase-panel'></mat-expansion-panel-header>
            <div class="usecase">
              <div [innerHTML]="productDetail.Transportation.Description"></div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
        <div class="card-flex">
          <app-bluebox></app-bluebox>
        </div>
      </div>

      <div class="usecase-cards">
        <figure>
          <img class="image-icon" src="{{productDetail.Government.Icon}}" alt="" />
        </figure>
        <div class="usecase-subheading">{{productDetail.Government.Heading}}</div>
        <mat-accordion>
          <mat-expansion-panel (opened)="panelOpenGovrmnt = true" (closed)="panelOpenGovrmnt = false">
            <mat-expansion-panel-header aria-label='usecase-panel'></mat-expansion-panel-header>
            <div class="usecase">
              <div [innerHTML]="productDetail.Government.Description"></div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
        <div class="card-flex">
          <app-bluebox></app-bluebox>
        </div>
      </div>

      <div class="usecase-cards">
        <figure>
          <img class="image-icon" src="{{productDetail.Medical.Icon}}" alt="" />
        </figure>
        <div class="usecase-subheading">{{productDetail.Medical.Heading}}</div>
        <mat-accordion>
          <mat-expansion-panel (opened)="panelOpenMedical = true" (closed)="panelOpenMedical = false">
            <mat-expansion-panel-header aria-label='usecase-panel'></mat-expansion-panel-header>
            <div class="usecase">
              <div [innerHTML]="productDetail.Medical.Description"></div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
        <div class="card-flex">
          <app-bluebox></app-bluebox>
        </div>
      </div>

      <div class="usecase-cards">
        <figure>
          <img class="image-icon" src="{{productDetail.Retail.Icon}}" alt="" />
        </figure>
        <div class="usecase-subheading">{{productDetail.Retail.Heading}}</div>
        <mat-accordion>
          <mat-expansion-panel (opened)="panelOpenRetail = true" (closed)="panelOpenRetail = false">
            <mat-expansion-panel-header aria-label='usecase-panel'></mat-expansion-panel-header>
            <div class="usecase">
              <div [innerHTML]="productDetail.Retail.Description"></div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
        <div class="card-flex">
          <app-bluebox></app-bluebox>
        </div>
      </div>

      <div class="usecase-cards">
        <figure>
          <img class="image-icon" src="{{productDetail.Sales.Icon}}" alt="" />
        </figure>
        <div class="usecase-subheading">{{productDetail.Sales.Heading}}</div>
        <mat-accordion>
          <mat-expansion-panel (opened)="panelOpenSales = true" (closed)="panelOpenSales = false">
            <mat-expansion-panel-header aria-label='usecase-panel'></mat-expansion-panel-header>
            <div class="usecase">
              <div [innerHTML]="productDetail.Sales.Description"></div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
        <div class="card-flex">
          <app-bluebox></app-bluebox>
        </div>
      </div>

    </div>
    <!--fiveg Auth usecases section end-->

    <!-- fiveg auth Easy deploy and manage content section start -->
    <div class="row detailsection" id="easyDeployDetails" *ngIf="EasyDeployArray && fivegauthpageflag && !isFn ">
      <div class="EasyDeployHeader"><strong>{{productDetail.EasyDeployHeader}}</strong></div>
      <div class="outerbox">
        <div class="largebox" *ngFor="let detail of EasyDeployArray">
          <div class="line"></div>
          <div class="largetext" [innerHTML]="detail"></div>
        </div>
      </div>
      <div class="outerbox">
        <div class="largebox rightbox">
          <div class="line"></div>
          <div class="largetext">{{productDetail.EasyDeployNote}}</div>
        </div>
      </div>
      <br>
    </div>
    <!-- <div class="easyDeployNote" *ngIf="EasyDeployArray && fivegauthpageflag && !isFn ">{{productDetail.EasyDeployNote}} -->
    <!-- </div> -->
    <!-- fiveg auth Easy deploy and manage content section end -->

    <!-- Details section start -->
    <div class="row detailsection appleDetails" id="details" *ngIf="detailsArray ">
      <div class="detailsheader"><strong>{{productDetail.detailsHeader}}</strong></div>
      <div class="outerbox" *ngIf="productDetail.firstNote">{{productDetail.firstNote}}</div>
      <div class="outerbox" *ngIf="(!abmpageflag && !fivegpageflag && !ztepageflag) && showKMEEnrollLink">
        <div class="smallbox" *ngFor="let detail of filteredDetailsArrayKME">
          <div class="line"></div>
          <div class="smalltext" [innerHTML]="detail"></div>
        </div>
      </div>
      <div class="outerbox" *ngIf="(!abmpageflag && !fivegpageflag && !ztepageflag) && !showKMEEnrollLink"> 
        <div class="smallbox" *ngFor="let detail of filteredDetailsArrayKME">
          <div class="line"></div>
          <div class="smalltext" [innerHTML]="detail"></div>
        </div>
      </div>
      <div class="outerbox" *ngIf="(!abmpageflag && !fivegpageflag && !kmepageflag) && !showZTEEnrollLink">
        <div class="smallbox" *ngFor="let detail of filteredDetailsArrayZTE; let i = index">
          <div class="line"></div>
          <div class="smalltext" [innerHTML]="i === 0 ? (showZTEEnrollLink ? detail : detail.replace('href', 'disabled')) : detail"></div>
        </div>
      </div>
      <div class="outerbox" *ngIf="(!abmpageflag && !fivegpageflag && !kmepageflag) && showZTEEnrollLink"> 
        <div class="smallbox" *ngFor="let detail of filteredDetailsArrayZTE">
          <div class="line"></div>
          <div class="smalltext" [innerHTML]="detail"></div>
        </div>
      </div>
      <div class="outerbox" *ngIf="(abmpageflag || fivegpageflag) && showABMEnrollLink">
        <div class="largebox" *ngFor="let detail of filteredDetailsArrayABM">
          <div class="line"></div>
          <div class="largetext" [innerHTML]="detail"></div>
        </div>
      </div>
      <div class="outerbox" *ngIf="(abmpageflag || fivegpageflag) && !showABMEnrollLink">
        <div class="largebox" *ngFor="let detail of filteredDetailsArrayABM">
          <div class="line"></div>
          <div class="largetext" [innerHTML]="detail"></div> 
        </div>
      </div>
      <br>
    </div>
    <!-- Details section end-->


    <!-- System Requirements section start -->
    <div class="row requirementsection appleReq" *ngIf="productDetail.requirements && !fivegpageflag"
      id="SystemRequirements">
      <div class="requirementsheader"><strong>{{productDetail.systemRequirementHeader}}</strong></div>
      <div class="outerbox">
        <div class="largebox" *ngFor="let requirement of requirementsArray">
          <div class="line"></div>
          <div class="largetext" [innerHTML]="requirement"></div>
        </div>
      </div>
      <br>
    </div>
    <div class="outerbox">
      <div class="moveleft" *ngIf="!abmpageflag &&!fivegpageflag" [innerHTML]="productDetail.thirdNote"></div>
    </div>
    <!-- System Requirements section end-->

    <div class="row requirementsection appleReq" id="moreInfoFAQ">
      <div class="requirementsheader"><strong>{{productDetail.moreInfoHeader}}</strong></div>
      <div class="outerbox" [innerHTML]="productDetail.forMoreInformation"></div>
      <div *ngIf="abmpageflag">
        <div [ngClass]="abmpageflag ? 'outerboxwithsmallfont' : 'outerbox'" [innerHTML]="productDetail.thirdNote"></div>
      </div>
      <div id="forMoreInfomation" class="outerbox" *ngIf="!fivegpageflag">
        <span>{{productDetail.forMoreInformation1}}
          <a href="javascript:void(0)" (click)="scrollUp()">{{productDetail.forMoreInformation2}}</a>
        </span>
      </div>
    </div>

  </div>
</main>